import { theme } from "mpulse-design-system";

// Background theme
theme.palette.background.default = theme.palette.grey[50];

export default theme;
